import Set from './Set';

/**
 * @see http://download.oracle.com/javase/6/docs/api/java/util/SortedSet.html
 *
 * @extends {Set}
 * @constructor
 * @private
 */
export default function SortedSet() {}
;
SortedSet.prototype = new Set();